__turbopack_context__.v({
  "groupDiscount": "gAJu4q_groupDiscount",
  "icon": "gAJu4q_icon",
  "iconInvalid": "gAJu4q_iconInvalid",
  "label": "gAJu4q_label",
  "legend": "gAJu4q_legend",
  "legendDot": "gAJu4q_legendDot",
  "legendItem": "gAJu4q_legendItem",
  "legendLabel": "gAJu4q_legendLabel",
  "lowStock": "gAJu4q_lowStock",
  "popover": "gAJu4q_popover",
  "roundingNote": "gAJu4q_roundingNote",
  "seasonal": "gAJu4q_seasonal",
  "value": "gAJu4q_value",
});
